export default __webpack_public_path__ + "maps-examples-runtime-toggle-layer-thumbnail-960-a9db5b2f6bfe04c6fe03c6c2ba5c3e61.png";